import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import { Download01, File05 } from '@kula-ai/icons-core';
import { downloadAttachment } from '../../../api/messages';
import type { MessageAttachment } from '../../../types/transcript';

export const AttachmentChip = ({
  sessionId,
  attachment,
}: {
  sessionId: string;
  attachment: MessageAttachment;
}) => {
  const onClick = () => {
    void downloadAttachment(sessionId, attachment);
  };
  return (
    <Flex
      as="button"
      onClick={onClick}
      align="center"
      gap="8px"
      px="10px"
      py="6px"
      borderRadius="10px"
      bg="base-white"
      border="1px solid"
      borderColor="border-color"
      maxW="100%"
      cursor="pointer"
      _hover={{ bg: 'secondary-50' }}
      title={`Download ${attachment.filename}`}
    >
      <Box as="span" flexShrink={0} color="secondary-500" aria-hidden>
        <File05 size={16} color="currentColor" />
      </Box>
      <Text
        variant="span"
        className="text-secondary-700 text-[14px]"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {attachment.filename}
      </Text>
      {/* Attachments on a sent turn have already been read + parsed by the
          agent, so the chip always reads as "Parsed". */}
      <Box
        as="span"
        flexShrink={0}
        px="8px"
        py="2px"
        borderRadius="6px"
        bg="pastel-2-light"
        color="pastel-2-dark"
        fontSize="12px"
        fontWeight="600"
      >
        Parsed
      </Box>
      <Box as="span" flexShrink={0} color="secondary-500" aria-hidden>
        <Download01 size={14} color="currentColor" />
      </Box>
    </Flex>
  );
};
